import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {DcpStripeService} from '../../stripe/dcp-stripe.service';
import {Invoke3ds, StripeActionTypes} from '../actions/stripe.action';
import {of} from 'rxjs';
import * as stripeActions from '../../store/actions/stripe.action';
import {PlaceOrderRequestBody} from '@app/model/order/dcp-place-order-body.model';
import {PaymentIntent} from '@stripe/stripe-js';
import Status = PaymentIntent.Status;

@Injectable()
export class StripeEffects {
  STATUSES_REQUIRING_ACTION: Status[] = ['requires_action', 'requires_confirmation'];

  constructor(private actions$: Actions, private dcpStripeService: DcpStripeService) {}

  startStripePaymentFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StripeActionTypes.StartStripePaymentFlow),
      map((a) => new stripeActions.CreatePaymentIntent())
    )
  );
  /**
   * create payment intent
   */
  createPaymentIntent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StripeActionTypes.CreatePaymentIntent),
      switchMap((a) =>
        this.dcpStripeService.createPaymentIntent().pipe(
          map((placeOrderRequestBody) => new stripeActions.Invoke3ds(placeOrderRequestBody)),
          catchError((error) => of(new stripeActions.CreatePaymentIntentFailure(error)))
        )
      )
    )
  );

  invoke3ds$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StripeActionTypes.Invoke3ds),
      switchMap((action: Invoke3ds) => {
        const paymentRequiresAction = this.getPaymentIntentsToConfirm(action.payload);
        return this.dcpStripeService.invoke3DS(paymentRequiresAction).pipe(
          map((_) => new stripeActions.CreatePaymentIntentSuccess(action.payload)),
          catchError((threeDsResult) => of(new stripeActions.Invoke3dsFailure(threeDsResult)))
        );
      })
    )
  );

  getPaymentIntentsToConfirm(response: PlaceOrderRequestBody): PaymentIntent[] {
    return response.paymentResponse
      .map((entry) => entry.value)
      .filter((pi: PaymentIntent) => this.STATUSES_REQUIRING_ACTION.includes(pi.status));
  }
}
